App.SmDatetimePickerComponent = Em.Component.extend
  classNames: [ 'sm-datetime-picker' ]

  value: null
  timezone: null

  clearButton: false

  actions:
    timeChanged: (value) ->
      @sendAction('onChange', value)
